import React, { useState, useContext, useEffect } from "react";
import { Modal, Box } from "@mui/material";
import { ModalWrapper, StyledBackdrop } from "../../../ProductOrder/single/AddProductModal/Styled";
import { TitleText } from "../../../MaterialOrder/single/AddMaterialModal/Styled";
import DateRangeFilter from "../../../../shared/components/FilterOption/DateRangeFilter";
import { ButtonWrapper } from "../../../../shared/components/CancelModal/Styled";
import CustomButton from "../../../../shared/components/TitleRow/CustomButton";
import FilterOption from "../../../../shared/components/FilterOption";
import { ProductQuantitySummaryFilterType } from "../../../../configs/filterTypes";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import LoadingButton from "../../../../shared/components/LoadingButton";

interface ExportQuantitySummaryModalProps { 
    open: boolean;
    handleClose: () => void;
    handleConfirm: (filters: {
        dateRange: [string | null, string | null];
    }) => Promise<void>; 
    isLoading?: boolean;
}

const ExportQuantitySummaryModal = ({ open, handleClose, handleConfirm, isLoading }: ExportQuantitySummaryModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [dateRange, setDateRange] = useState<[string | null, string | null]>([null, null]);

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    const handleDateRangeChange = (value: [string | null, string | null]) => {
        setDateRange(value);
    };

    const handleConfirmWithAnimation = () => {
        handleConfirm({
            dateRange,
        });
        setTimeout(handleClose, 100);
    };


    return (
        <Modal open={open}
        onClose={handleCloseWithAnimation}
        closeAfterTransition
        BackdropComponent={StyledBackdrop}
        BackdropProps={{
            timeout: 500,
            onClick: (e) => e.stopPropagation(),
        }}>
            <ModalWrapper isOpen={isOpen} style={{width: "30vw", minHeight: "auto"}}> 
                <TitleText>Báo cáo nhập xuất tồn</TitleText>
                <Box sx={{ p: 2 }}>
                    <DateRangeFilter
                        onChangeValue={handleDateRangeChange}
                        isReset={false}
                    />
                </Box>

                <ButtonWrapper>
                    <CustomButton
                        title="Đóng"
                        onClick={handleCloseWithAnimation}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                    />
                   <LoadingButton
                        text="Xuất báo cáo"
                        variant="contained"
                        onClick={handleConfirmWithAnimation}
                        disabled={dateRange[0] === null || dateRange[1] === null}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                        isLoading={isLoading}
                    />
                </ButtonWrapper>
            </ModalWrapper>
        </Modal>
    );
};

export default ExportQuantitySummaryModal;
